document.addEventListener("click", event => {
  const passwordToggle = event.target.closest(".js-toggle-password");
  if (passwordToggle) {
    const passwordInput = passwordToggle.closest(".form__field").querySelector("input");
    if (passwordToggle.classList.contains("password-toggle--shown")) {
      passwordInput.setAttribute("type", "password");
      passwordToggle.classList.remove("password-toggle--shown");
    } else {
      passwordInput.setAttribute("type", "text");
      passwordToggle.classList.add("password-toggle--shown");
    }
    passwordInput.focus();
  }
});
